import { VENDOR_KEY } from "constants/vendor";

export const makeVendorQueryVariables = (vendor?: VENDOR_KEY) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (vendor) {
    case VENDOR_KEY.TERRAFORM:
    case VENDOR_KEY.OPEN_TOFU:
      // openTofuVersions is gated behind includeTerraform in the query.
      return {
        includeTerraform: true,
        includeTerragrunt: false,
        includeKubectl: false,
      };

    case VENDOR_KEY.TERRAGRUNT:
      return {
        includeTerraform: true,
        includeTerragrunt: true,
        includeKubectl: false,
      };

    case VENDOR_KEY.KUBERNETES:
      return {
        includeTerraform: false,
        includeTerragrunt: false,
        includeKubectl: true,
      };

    default:
      return {
        includeTerraform: true,
        includeTerragrunt: true,
        includeKubectl: true,
      };
  }
};
